import React from 'react';
import Reflux from 'reflux';
import {Button, Row, Col, Modal, Radio, Select, Input, Table, message} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice} from 'Utils';
import {
    getChooseOrderTraceBackList, getAddOrderTraceBackList, getGouXiaoUnitList,
    getProductLineList, getOrderTraceBackItemList, getUpdateorderTraceBackItem,
    getDelOrderTraceBackItem, submitOrderTraceBack,
    getOrderTraceBackHead, saveOrderTraceBack,
    getCustomer, getPurchases
} from '../../service/traceOrder';
import {fetchArea} from "../../service/billingCtrl";

class TraceOrderAdd extends Reflux.Component {
    constructor(props) {
        super(props);
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        this.state = {
            channelCode: this.channelData.split('|')[1] || '',
            opts: ['追溯订单'],
            showHideBtnIndex: '',
            key: 0,
            selectedRowsAllKeys: [],
            selectedRowKeys: [],
            selectedRowKeysWuliao: [],
            dataSource: [],
            gouxiaoUnitList: [],
            productLineData: [],
            selectedWuliaoRowkeys: [],
            rows: [],
            rowsOutSide: [],
            total: 1,
            itemNum: "",//物料编码
            itemDesc: "", //物料描述
            deliveryId: "", //出库单号
            lineId: "", //发票池Id
            dataSourceTotal: 1,
            userName: JSON.parse(window.localStorage.getItem('login_user_information')).userName,
            param: {
                id: '',
                qty: '',
                correctPrice: ''
            },
            submitParam: {
                salesUnitId: '',
                salesUnitName: '',
                //proLine: '',
                salesChannelCode: window.sessionStorage.getItem('cur_channelId')
            },
            searchObj: {
                name: '',
                id: '',
                //productLine: '',
                orderStatus: '',
                salesUnitName: '',
                taxCode: 13,
                salesUnitId: '',
                startCreatedDate: '',
                endCreatedDate: '',
                salesChannelCode: this.channelData.split('|')[1] || '',
                s: 10,
                p: 1
            },

            addSearchObj: {
                //productLine: '',
                taxCode: 13,
                salesUnitId: '',
                salesChannelCode: this.channelData.split('|')[1] || '',
                s: 10,
                p: 1
            },

            searchObj1: {
                salesUnitName: '',
                s: 10,
                p: 1
            },
            categoryData: [],
            visible: false,
            value: '',
            customer: {},
            detail: {
                taxCode: 13
            },
            subDisabled: false,
            loading: false
        };
        this.taxRateOptions = [
            {
                id: '16',
                text: '16%',
            }, {
                id: '17',
                text: '17%',
            }, {
                id: '13',
                text: '13%',
            }, {
                id: '6',
                text: '6%',
            }, {
                id: '0',
                text: '0%',
            }
        ];
        this.pageChange = this.pageChange.bind(this);
        this.addPageChange = this.addPageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.cutomerMsg = this.cutomerMsg.bind(this);
        this.purchasesMsg = this.purchasesMsg.bind(this);
        this.traceBackList = this.traceBackList.bind(this);
        this.onSelectChangeProLine = this.onSelectChangeProLine.bind(this)
        //张清富
        this.onOutsideSelectChange = this.onOutsideSelectChange.bind(this)
    };


    /*
     客户信息
     */
    cutomerMsg = () => {
        getCustomer().then(result => {
            if (result.status && result.code == 200) {
                this.setState({customer: result.data});
            } else {
                message.error(result.message);
            }
        });
    }

    /*
     购货单位信息
     */
    purchasesMsg = (param) => {
        getPurchases(param).then(result => {
            if (result.status && result.code == 200) {
                this.state.detail.salesUnitId = result.data[0].id;
                this.state.submitParam.salesUnitId = result.data[0].id;
                this.state.submitParam.salesUnitName = result.data[0].name;
                let searchObj = {...this.state.searchObj};
                let addSearchObj = {...this.state.addSearchObj};
                searchObj.salesUnitId = result.data[0].id;
                addSearchObj.salesUnitId = result.data[0].id;
                this.setState({
                    searchObj: searchObj,
                    addSearchObj: addSearchObj,
                    gouxiaoUnitList: result.data,
                    detail: {...this.state.detail},
                    submitParam: {...this.state.submitParam}
                }, () => {
                    const id = this.props.params.id;
                    if (id) {
                        this.getDetail(id);
                    }
                });
            } else {
                message.error(result.message);
            }
        });
    }
    onSelectItem = (selectedRowsKey, selectedRows) => {
        this.setState({selectedWuliaoRowkeys: selectedRowsKey, selectedRowKeysWuliao: selectedRows});
    }

    onSelectChangeProLine = (item) => {
        let submitParam = {...this.state.submitParam};
        let searchObj = {...this.state.searchObj};
        let addSearchObj = {...this.state.addSearchObj};
        searchObj.productLine = item.key;
        addSearchObj.productLine = item.key;
        submitParam.proLine = item.key;
        this.state.searchObj.productLine = item;
        this.setState({submitParam: submitParam});
        this.state.addSearchObj.productLine = item;
        this.setState({addSearchObj: addSearchObj});
        this.setState({searchObj: searchObj});
        this.setState({rows: []});
        this.setState({detail: {...this.state.detail, proLine: item.key, productLineName: item.label}});
    }
    onSelectChangeGouHuoUnit = (item) => {
        this.state.submitParam.salesUnitId = Number(item);
        this.state.detail.salesUnitId = Number(item);
        this.state.submitParam.salesUnitName = this.state.gouxiaoUnitList.filter(it => it.id === ~~item)[0].name;
        this.setState({submitHandle: {...this.state.submitParam}, detail: {...this.state.detail}});
        this.state.searchObj.salesUnitId = Number(item);
        this.setState({searchObj: {...this.state.searchObj}});
        this.state.addSearchObj.salesUnitId = Number(item);
        this.setState({addSearchObj: {...this.state.addSearchObj}});
        this.setState({rows: []});
    }

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    goBack() {
        hashHistory.goBack();
    };

    /*筛选*/
    setFilterParam(name, value) {
    };

    /*筛选重置*/
    advanceReset() {
    };

    /* 筛选确认 */
    advanceSubmit(form) {
        let self = this;
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }
        });
    };

    /*删除*/
    deleteChange() {
        if (this.state.rowsOutSide.length === 0) {
            openNotice('warning', '请选择产品');
            return;
        }
        const ds = [...this.state.rows];
        const arr = ds.filter(item => !this.state.rowsOutSide.includes(item.lineId));
        const selected = [];
        arr.forEach(item => {
            selected.push(item.key)
        });
        this.setState({rows: arr, selectedRowsAllKeys: [...selected]});
    };

    //数量
    countChange = (record, e) => {
        // if (e.target.value < 0) {
        //     openNotice('error', '数量不能为负数！', '');
        //     e.target.value = 0;
        //     return;
        // } else if (e.target.value > record.orderQuantity) {
        //     openNotice('error', '数量必须不能大于可用数量！', '');
        //     e.target.value = 0;
        //     return;
        // } else {
        record.qty = e.target.value;
        // debugger;
        record.priceDiff = ((record.correctPrice || 0) - record.unitSellingPrice).toFixed(6);
        record.outAmount = (record.unitSellingPrice * record.qty).toFixed(6);
        record.correctAmount = ((record.correctPrice || 0) * record.qty).toFixed(6);
        record.amountDiff = (record.correctAmount - record.outAmount).toFixed(6);
        for (let i = 0; i < this.state.rows.length; i++) {
            if (record.lineId == this.state.rows[i].lineId) {
                this.state.rows.splice(i, 1, record);
                this.setState({rows: this.state.rows});
                return;
            }
        }
        //}
    }
    //正确单价
    priceChange = (record, e) => {
        if (e.target.value < 0) {
            openNotice('error', '数量不能为负数！', '');
            e.target.value = 0;
            return;
        } else {
            // debugger;
            record.correctPrice = e.target.value;
            record.priceDiff = (record.correctPrice - record.unitSellingPrice).toFixed(6);
            record.outAmount = (record.unitSellingPrice * (record.qty || 0)).toFixed(6);
            record.correctAmount = (record.correctPrice * (record.qty || 0)).toFixed(6);
            record.amountDiff = (record.correctAmount - record.outAmount).toFixed(6);
            for (let i = 0; i < this.state.rows.length; i++) {
                if (record.lineId == this.state.rows[i].lineId) {
                    this.state.rows.splice(i, 1, record);
                    this.setState({rows: this.state.rows});
                    return;
                }
            }
        }
    }
    //输入数量和价格
    change = (record, fileds, e) => {
        let self = this;
        let data = self.state.rows;
        if (fileds == 'qty') {
            data.forEach(x => {
                if ((x.inventoryItemId == record.inventoryItemId) && (x.deliveryId == record.deliveryId)) {
                    x.qty = e.target.value;
                }
            });
            //	this.state.param.qty = e.target.value;

        } else if (fileds == 'correctPrice') {
            data.forEach(x => {
                if ((x.inventoryItemId == record.inventoryItemId) && (x.deliveryId == record.deliveryId)) {
                    x.correctPrice = e.target.value;
                }
            });
        }
        this.setState({rows: data});
    }

    pageChange(page, pageSize) {
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}});
    }

    addPageChange(page, pageSize) {
        this.setState({addSearchObj: {...this.state.addSearchObj, s: pageSize, p: page}}, () => {
            this.getAddArray();
        });
    }

    /*获取列表数据*/
    traceBackList() {
        if (this.state.searchObj.salesUnitId == '') {
            openNotice("error", "请选择购货单位");
            return;
        }
        // if (this.state.searchObj.productLine == '') {
        //     openNotice("error", "请选择产品线");
        //     return;
        // }
        this.setState({
            dataSource: [],
            dataSourceTotal: 0,
            itemNum: '',
            itemDesc: '',
            deliveryId: '',
            lineId: '',
        });
        // console.log(this.state.lineId);

        this.setState({visible: true});

        /*getChooseOrderTraceBackList(
            this.state.addSearchObj
        ).then(result => {
            if (result.status) {
                this.setState({
                    //默认查询数据
               /!*    dataSource: result.data || [],
                    dataSourceTotal: result.total*!/
                }, () => {
                    this.setState({visible: true});
                });
            } else {
                message.error(result.message);
            }
        });*/

    }

    /*
     列表选择改变事件
     */
    onOutsideSelectChange = (selectedRowKeys, selectedRows) => {
        this.setState({rowsOutSide: selectedRowKeys});
    }

    // 物料编码
    itemNumChange = (event) => {
        this.setState({
            itemNum: event.target.value,
            ...this.state.addSearchObj,
            addSearchObj: {p: 1, s: this.state.addSearchObj.s}
        });
    }
    // 物料名称
    itemDescChange = (event) => {
        this.setState({
            itemDesc: event.target.value,
            ...this.state.addSearchObj,
            addSearchObj: {p: 1, s: this.state.addSearchObj.s}
        });
    }
    // 出库单号
    deliveryIdChange = (event) => {
        this.setState({
            deliveryId: event.target.value,
            ...this.state.addSearchObj,
            addSearchObj: {p: 1, s: this.state.addSearchObj.s}
        });
    }
    lineId
    // 发票池ID
    lineIdChange = (event) => {
        this.setState({
            lineId: event.target.value,
            ...this.state.addSearchObj,
            addSearchObj: {p: 1, s: this.state.addSearchObj.s}
        });
    }
    //搜索
    getAddArray = () => {
        this.setState({loading: true});
        getChooseOrderTraceBackList({
            salesChannelCode: this.state.searchObj.salesChannelCode,
            salesUnitId: this.state.searchObj.salesUnitId,
            taxCode: this.state.searchObj.taxCode,
            itemNum: this.state.itemNum,
            itemDesc: this.state.itemDesc,
            deliveryId: this.state.deliveryId,
            lineId: this.state.lineId,
            //productLine: this.state.searchObj.productLine,
            p: this.state.addSearchObj.p,
            s: this.state.addSearchObj.s,
        }).then(result => {
            if (result.status && result.code == 200) {
                this.setState({
                    dataSource: result.data || [],
                    dataSourceTotal: result.total || 1,
                    loading: false
                })
            } else {
                openNotice('error', '获取产品类别失败', result.message || '');
            }
        })
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
        this.cutomerMsg();
    }

    componentDidMount() {
        getProductLineList().then(result => { //产品线
            if (result.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                for (let i = 0; i < result.data.length; i++) {
                    let x = result.data[i];
                    arr.push({
                        text: x.name,
                        value: x.code
                    })
                }
                this.setState({
                        productLineData: arr
                    }, () => {
                        this.purchasesMsg({channelCode: this.state.channelCode});
                    }
                )
            } else {
                message.error(result.message);
            }
        })
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    getDetail(id) {
        getOrderTraceBackHead(id).then(res => {
            if (res.code === 200) {
                const data = res.data;
                let prolineVisible = false;
                if (data != null && data.id != null) {

                    prolineVisible = true;
                    // console.log(prolineVisible)
                }
                console.log(data);
                this.setState({
                    detail: data,
                    rows: data.lineBackList,
                    prolineVisible: prolineVisible,
                    searchObj: {
                        salesUnitId: data.salesUnitId,
                        //productLine: data.proLine,
                        salesChannelCode: data.salesChannelCode,
                        taxCode: data.taxCode,
                        p: 1,
                        s: 10
                    },
                    addSearchObj: {
                        salesUnitId: data.salesUnitId,
                        //productLine: data.proLine,
                        salesChannelCode: data.salesChannelCode,
                        taxCode: data.taxCode,
                        p: 1,
                        s: 10
                    },
                    submitParam: {
                        ...this.state.submitParam,
                        salesUnitId: data.salesUnitId,
                        salesUnitName: data.salesUnitName
                    }
                });
            }
        });
    }

    // 点击提交按钮
    submitHandle(type) {
        const id = this.props.params.id;
        var self = this;
        self.setState({subDisabled: true});
        let rowsData = this.state.rows;
        // console.log(rowsData.length)
        for (let i = 0; i < rowsData.length; i++) {
            if (!rowsData[i].qty || !rowsData[i].correctPrice) {
                openNotice('warning', '数量或出库单价不能为空！');
                self.setState({subDisabled: false});
                return;
            }
        }
        if (this.state.submitParam.salesUnitName == '') {
            openNotice('warning', '请选择购货单位！');
            self.setState({subDisabled: false});
            return;
        }
        let data = this.state.submitParam;
        data.cusId = this.state.customer.thirdId;
        data.cusCode = this.state.customer.code;
        data.cusName = this.state.customer.name;
        data.lineBackList = this.state.rows;
        data.taxCode = this.state.searchObj.taxCode;
        data.proLine = this.state.detail.proLine;
        if (id) {
            data.id = id;
        }
        if (type === 'submit') {
            submitOrderTraceBack(data).then((result) => {
                if (result && result.code == 200) {
                    hashHistory.goBack();
                    self.setState({subDisabled: false});
                } else {
                    message.error(result.message);
                    self.setState({subDisabled: false});
                }
            });
        } else {
            saveOrderTraceBack(data).then((result) => {
                if (result && result.code == 200) {
                    hashHistory.goBack();
                    self.setState({subDisabled: false});
                } else {
                    message.error(result.message);
                    self.setState({subDisabled: false});
                }
            });
        }
    };

    showHideBtn(index) {
        this.setState({
            showHideBtnIndex: index
        });
    }

    hideBtn() {
        this.setState({
            showHideBtnIndex: ''
        });
    }

    handleOk = () => {
        this.state.rows = this.state.rows.concat(this.state.selectedRowKeysWuliao);
        const selected = [];
        this.state.rows.forEach(item => {
            selected.push(item.lineId);
        });
        this.setState({
            rows: this.state.rows,
            selectedRowsAllKeys: [...this.state.selectedRowsAllKeys, ...selected],
            visible: false,
            selectedWuliaoRowkeys: [],
            rowsOutSide: []
        });
    }

    handleCancel = () => {
        this.setState({visible: false});
    }

    onChange = (e) => {
        this.setState({
            value: e.target.value
        });
    }

    /**
     * 税率改变
     */
    changeSelect(value, type) {
        let self = this;
        var searchObj1 = {...self.state.searchObj}
        searchObj1.taxCode = value;
        var searchObj2 = {...self.state.addSearchObj}
        searchObj2.taxCode = value;
        this.setState({
            searchObj: searchObj1,
            addSearchObj: searchObj2,
            detail: {...this.state.detail, taxCode: value},
            rows: []
        });

    };

    handleChange() {

    }

    onChange = (e) => {
        this.setState({
            value: e.target.value
        });
    }


    addSave(record) {
        const {rows, selectedRowsAllKeys, selectedWuliaoRowkeys, selectedRowKeysWuliao} = this.state;
        if (selectedRowsAllKeys.includes(record.lineId)) {
            openNotice('warning', '物料已添加');
            return
        }
        const arr1 = selectedWuliaoRowkeys.filter(item => item !== record.lineId);
        const arr2 = selectedRowKeysWuliao.filter(item => item.lineId !== record.lineId);
        this.setState({
            selectedWuliaoRowkeys: [...arr1],
            selectedRowKeysWuliao: [...arr2],
            selectedRowsAllKeys: [...selectedRowsAllKeys, record.lineId],
            rows: [...rows, record]
        })
    }

    calcRowsSummary(rows) {
        let totalQty = 0;
        let totalCorrectAmount = 0;
        let totalAmountDiff = 0;
        (rows || []).forEach(row => {
            const qty = Number(row.qty) || 0;
            const unitPrice = Number(row.unitSellingPrice) || 0;
            const correctPrice = Number(row.correctPrice) || 0;
            const outAmount = row.outAmount !== undefined && row.outAmount !== null && row.outAmount !== ''
                ? Number(row.outAmount)
                : Number((unitPrice * qty).toFixed(4));
            const correctAmount = row.correctAmount !== undefined && row.correctAmount !== null && row.correctAmount !== ''
                ? Number(row.correctAmount)
                : Number((correctPrice * qty).toFixed(4));
            const amountDiff = row.amountDiff !== undefined && row.amountDiff !== null && row.amountDiff !== ''
                ? Number(row.amountDiff)
                : Number((correctAmount - outAmount).toFixed(4));
            totalQty += qty;
            totalCorrectAmount += correctAmount;
            totalAmountDiff += amountDiff;
        });
        return {
            rowCount: (rows || []).length,
            qty: totalQty,
            correctAmount: totalCorrectAmount.toFixed(4),
            amountDiff: totalAmountDiff.toFixed(4),
        };
    }

    render() {
        const {
            opts, key, rows, rowsOutSide, selectedWuliaoRowkeys, dataSource, dataSourceTotal, gouxiaoUnitList,
            productLineData, total, searchObj, detail, taxRateOptions, prolineVisible, addSearchObj,
            visible, loading
        } = this.state;
        const rowsSummary = this.calcRowsSummary(rows);
        const tableViewProps = {
            loading: false,//更新表格数据中
            rowKey: 'lineId',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '物料编码',
                    dataIndex: 'itemNum'
                },
                {
                    title: '购货单位',
                    dataIndex: 'salesUnitName'
                },
                {
                    title: '产品线',
                    dataIndex: 'prductLineName'
                },
                {
                    title: '物料描述',
                    dataIndex: 'itemDesc'
                },
                {
                    title: '出库单号',
                    dataIndex: 'deliveryId'
                },
                {
                    title: '发票池ID',
                    dataIndex: 'lineId'
                },
                {
                    title: '可用数量',
                    dataIndex: 'orderQuantity'
                },
                {
                    title: '数量',
                    dataIndex: 'qty',
                    render: (text, record, index) => {
                        return (<Input type='number' style={{width: 50}} value={record.qty}
                                       onChange={this.countChange.bind(this, record)}/>)
                    }
                },
                {
                    title: '出库单价',
                    dataIndex: 'unitSellingPrice'
                },
                {
                    title: '正确单价',
                    dataIndex: 'correctPrice',
                    render: (text, record, index) => {
                        return (<Input type='number' style={{width: 80}} value={record.correctPrice}
                                       onChange={this.priceChange.bind(this, record)}/>)
                    }
                },
                {
                    title: '单价差额',
                    dataIndex: 'priceDiff'
                },
                {
                    title: '出库总额',
                    dataIndex: 'outAmount'
                },
                {
                    title: '正确总额',
                    dataIndex: 'correctAmount'
                },
                {
                    title: '总额差异',
                    dataIndex: 'amountDiff'
                }
            ],
            rows,
            rowSelection: {
                selectedRowKeys: rowsOutSide,
                onChange: this.onOutsideSelectChange
            }
        };

        const addProps = {
            rowKey: 'lineId',
            loading: loading,//更新表格数据中
            pageParam: {
                total: dataSourceTotal,
                current: addSearchObj.p,//当前页码
                pageSize: addSearchObj.s,//当前分页数
                onChange: this.addPageChange
            },
            columns: [
                {
                    title: '物料编码',
                    dataIndex: 'itemNum'
                }, {
                    title: '物料名称',
                    dataIndex: 'itemDesc'
                }, {
                    title: '出库单号',
                    dataIndex: 'deliveryId'
                }, {
                    title: '发票池ID',
                    dataIndex: 'lineId'
                }, {
                    title: '可用数量',
                    dataIndex: 'orderQuantity'
                }, {
                    title: '出库单价',
                    dataIndex: 'unitSellingPrice'
                }, {
                    title: '操作',
                    dataIndex: 'save',
                    width: 100,
                    render: (text, record, index) => (
                        <Button style={{background: '#red'}} icon="plus"
                                onClick={this.addSave.bind(this, record)}>添加</Button>)
                }],
            rows: dataSource/*,
            rowSelection: {
                selectedRowKeys: selectedWuliaoRowkeys,
                onChange: this.onSelectItem,
                getCheckboxProps: record => ({
                    disabled: this.state.selectedRowsAllKeys.includes(record.lineId)
                })
            }*/
        }
        return <div>
            <DmsTab options={opts} defaultKey={key}>
                <Button type='primary' onClick={this.submitHandle.bind(this, 'submit')}
                        disabled={this.state.subDisabled}>提交</Button>
                <Button type='primary' onClick={this.submitHandle.bind(this, 'save')}
                        disabled={this.state.subDisabled}>保存</Button>
                <Button onClick={this.goBack}>返回</Button>
            </DmsTab>
            <div className="dms-table-box">
                <Row>
                    <Col span={6}>
                        <label>订单日期：</label>
                        <span>{detail.orderDate || new Date().format('yyyy-MM-dd')}</span>
                    </Col>
                    <Col span={6}>
                        <label>客户编号：</label>
                        <span>{this.state.customer.code}</span>
                    </Col>
                    <Col span={6}>
                        <label>客户名称：{this.state.customer.name}</label>
                    </Col>
                    <Col span={6}>
                        <label className="ant-form-item-required">购货单位：</label>
                        <Select
                            value={detail.salesUnitId + ''}
                            placeholder="请选择购货单位"
                            style={{minWidth: 250}}
                            onSelect={this.onSelectChangeGouHuoUnit}
                        >
                            {
                                gouxiaoUnitList.map((item, index) => {
                                    return <Select.Option key={item.id + ''}
                                                          value={item.id + ''}>{item.name}</Select.Option>
                                })
                            }
                        </Select>
                    </Col>
                </Row>
                <Row>
                    <Col span={6}>
                        <label className="ant-form-item-required">税率：</label>
                        <Select value={this.state.detail.taxCode + '%'} style={{width: '100px'}}
                                onChange={(value) => {
                                    this.changeSelect(value, 'taxCode')
                                }}>
                            {this.taxRateOptions.map(item => <Select.Option key={item.id}
                                                                            value={item.id}>{item.text}</Select.Option>)}
                        </Select>
                    </Col>
                    {/*<Col span={8} style={{marginTop: 10}}>*/}
                    {/*    <label className="ant-form-item-required">产品线：</label>*/}
                    {/*    <Select*/}
                    {/*        defaultValue={{key: '全部'}}*/}
                    {/*        value={{*/}
                    {/*            key: detail.proLine,*/}
                    {/*            lable: detail.productLineName*/}
                    {/*        }}*/}
                    {/*        placeholder="请选择产品线"*/}
                    {/*        labelInValue*/}
                    {/*        onChange={this.onSelectChangeProLine}*/}
                    {/*        style={{minWidth: 180}}>*/}
                    {/*        {*/}
                    {/*            productLineData.map((item, index) => {*/}
                    {/*                return <Select.Option key={item.code + ''}*/}
                    {/*                                      value={item.value + ''}>{item.text}</Select.Option>*/}
                    {/*            })*/}
                    {/*        }*/}
                    {/*    </Select>*/}
                    {/*</Col>*/}
                </Row>
            </div>
            <div>
                <DmsTab className="white-bg no-border" options={['订单物料']} defaultKey={0}/>
                <div className="dms-table-box">
                    <div style={{marginBottom: 8, position: 'relative', minHeight: 32}}>
                        <Button onClick={this.traceBackList.bind(this)}>选择</Button>
                        <Button style={{marginLeft: 10}} onClick={this.deleteChange.bind(this)}>删除</Button>
                        <div style={{position: 'absolute', right: 0, top: 0, lineHeight: '32px'}}>
                            <span style={{marginRight: 16}}>汇总：行数：{rowsSummary.rowCount}</span>
                            <span style={{marginRight: 16}}>数量：{rowsSummary.qty}</span>
                            <span style={{marginRight: 16}}>正确总额：{rowsSummary.correctAmount}</span>
                            <span>总额差异：{rowsSummary.amountDiff}</span>
                        </div>
                    </div>
                    <TableView {...tableViewProps} />
                </div>
            </div>

            <Modal
                visible={visible}
                title="选择物料"
                onOk={this.handleOk.bind(this)}
                onCancel={this.handleCancel.bind(this)}
                maskClosable={false}
                width={1200}
            >
                <div>
                    <Row>
                        <Col span={4}><label>物料编码：</label><Input style={{width: 100}} value={this.state.itemNum}
                                                                     onChange={this.itemNumChange}/></Col>
                        <Col span={4}><label>物料名称：</label><Input style={{width: 100}} value={this.state.itemDesc}
                                                                     onChange={this.itemDescChange}/></Col>
                        <Col span={4}><label>出库单号：</label><Input style={{width: 100}} value={this.state.deliveryId}
                                                                     onChange={this.deliveryIdChange}/></Col>
                        <Col span={4}><label>发票池ID：</label><Input style={{width: 100}} value={this.state.lineId}
                                                                     onChange={this.lineIdChange}/></Col>
                        <Col span={4}><Button onClick={this.getAddArray}>搜索</Button></Col>
                    </Row>
                    <TableView {...addProps} bordered style={{marginTop: 10}}/>

                </div>
            </Modal>

        </div>
    }
}
;
export default withRouter(TraceOrderAdd);


// WEBPACK FOOTER //
// ./src/routes/traceOrder/add.js